module.exports = __webpack_public_path__ + "img/dehsen.com__lighthouse-score.7e0f6d36.jpg";